<!--suppress HtmlRequiredAltAttribute -->

<ng-container *ngIf="imageUrl">
  <img [src]="imageUrl" />
</ng-container>

<span>{{ text }}</span>
